import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from '@angular/core';
import { AccountingResult, Invoice } from '@jms/model';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { invoiceAccountingListCell, invoiceAccountingResult, InvoiceAccountingListCell } from './invoice.accounting.cell';

@Component({
  selector: 'invoice-accounting-cell-renderer',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: flex; align-items: center; min-width: 0; height: 100%; overflow: hidden;' },
  template: `
    @if ($cell(); as cell) {
      @if (cell.kind === 'logo' && cell.logo) {
        <img [src]="cell.logo" [alt]="cell.label" [title]="cell.label" style="display: block; height: 28px; width: auto;" />
      } @else {
        <span [title]="cell.label" style="font-style: italic; color: var(--wb-color-text-tertiary, #667085);">{{ cell.label }}</span>
      }
    }
  `,
})
export class InvoiceAccountingCellRendererComponent implements ICellRendererAngularComp {

  protected readonly $cell = signal<InvoiceAccountingListCell | null>(null);

  public agInit(params: ICellRendererParams<Invoice, AccountingResult>): void {

    this.read(params);
  }

  public refresh(params: ICellRendererParams<Invoice, AccountingResult>): boolean {

    this.read(params);
    return true;
  }

  private read(params: ICellRendererParams<Invoice, AccountingResult>): void {

    this.$cell.set(invoiceAccountingListCell(invoiceAccountingResult(params.value) ?? params.data?.integration));
  }
}
